import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export default function PublicSeoSections({ sections }) {
  return (
    <section className="grid gap-6 md:grid-cols-2">
      {sections.map((section) => (
        <Card key={section.title} className="glass-maritime-subtle">
          <CardContent className="p-6">
            <h2 className="font-heading text-2xl font-bold text-foreground">{section.title}</h2>
            <ul className="mt-5 space-y-3">
              {section.items.map((item) => (
                <li key={item} className="flex gap-3 text-sm leading-6 text-muted-foreground">
                  <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </CardContent>
        </Card>
      ))}
    </section>
  );
}